import { Navigate, useLocation } from 'react-router-dom';

export const RedirectSubmissionsLegacy = () => {
  const location = useLocation();
  const newPath = location.pathname.replace('/submissions', '/contracts');
  return <Navigate to={newPath} replace state={{ from: location }} />;
};
